import React, {useState,useEffect} from 'react';
import {Link, NavLink} from 'react-router-dom';
import './Navbar.css';
function Navbar() {

    return (
        <>
        <nav className="navbar NavbarTest">
            <div className="navbar-container">
                <ul className="nav-menu">
                    <li className="nav-item">
                        <NavLink to="/job-readiness" className="nav-links" activeClassName="is-active">Home</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/skill-learning-journey" className="nav-links" activeClassName="is-active">Skill Journey</NavLink>
                    </li>
                   {/* <li className="nav-item">
                        <NavLink to="/assessment-planner" className="nav-links" activeClassName="is-active">Assessment Rescheduler</NavLink>
                    </li>  */}
                    <li className="nav-item">
                        <NavLink to="/key-statistics" className="nav-links" activeClassName="is-active">Key Statistics</NavLink>
                    </li>
                    {/* <li className="nav-item">
                        <NavLink to="/faq" className="nav-links" activeClassName="is-active">FAQs</NavLink>
                    </li> */}
                    <li className="nav-item">
                        <NavLink to="/contact" className="nav-links" activeClassName="is-active">Contact</NavLink>
                    </li>
                    
                </ul>
            </div>
        </nav>

        
        </>
    )
}


export default Navbar
